import React from "react";
import { useFormContext } from "react-hook-form";
import * as yup from "yup";

import { PaziaTextQuestionTypeSwitch } from "../../TextQuestionTypeSwitch/PaziaTextQuestionTypeSwitch";
import { useSurvey } from "pages/SurveyCreate/store/reducer";
import { questionBaseSchema } from "./BaseQuestionForm";
import { QuestionForm } from "./QuestionForm";
import { Question, TextQuestionTypes } from "survey";
import { PaziaCheckbox, PaziaTextarea } from "components/atoms";

interface TextQuestionFormProps {
  question: Question;
}

export const TextQuestionForm = (props: TextQuestionFormProps) => {
  const { question } = props;
  const { dispatch } = useSurvey();
  const methods = useFormContext<any>();

  const onTypeChange = (type: TextQuestionTypes) => {
    methods.setValue(QUESTION_TEXT_FORM_NAMES.PLACEHOLDER, placeholders[type]);
    dispatch({
      type: "UPDATE_QUESTION",
      payload: { ...question, textType: type, placeholder: placeholders[type] },
    });
  };

  const onPlaceholderChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    dispatch({
      type: "UPDATE_QUESTION",
      payload: { ...question, placeholder: e.target.value },
    });
  };

  return (
    <QuestionForm question={question}>
      <PaziaTextarea label="Placeholder" name={QUESTION_TEXT_FORM_NAMES.PLACEHOLDER} onChange={onPlaceholderChange} />
      <PaziaCheckbox label="Pozwól dołączyć plik" name={QUESTION_TEXT_FORM_NAMES.ALLOW_ATTACHMENTS} />

      <PaziaTextQuestionTypeSwitch name={QUESTION_TEXT_FORM_NAMES.TEXT_TYPE} onChange={onTypeChange} />
    </QuestionForm>
  );
};

const placeholders: { [key in TextQuestionTypes]: string } = {
  text: "Wprowadź swoją odpowiedź tutaj...",
  email: "przyklad@gmail.com",
  url: "https://...",
  number: "Wpisz liczbę...",
  phone: "+48 000 000 000",
};
export const QUESTION_TEXT_FORM_NAMES = {
  PLACEHOLDER: "placeholder",
  ALLOW_ATTACHMENTS: "allowAttachments",
  TEXT_TYPE: "textType",
} as const;

const questionTextFormSchema = yup
  .object({
    [QUESTION_TEXT_FORM_NAMES.TEXT_TYPE]: yup.string().required(),
  })
  .required();
export const textQuestionSchema = questionTextFormSchema.concat(questionBaseSchema);

export type TextQuestionFormValues = yup.InferType<typeof textQuestionSchema>;
